module.exports = [{
      plugin: require('/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
